import React from "react";
import { CircleAlert } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

export type StatisticsInlineErrorProps = {
  message: string;
  action?: string;
  className?: string;
};

export function StatisticsInlineError({
  message,
  action,
  className,
}: StatisticsInlineErrorProps): React.ReactElement {
  return (
    <Alert variant="error" className={cn("rounded-lg py-2", className)}>
      <CircleAlert />
      <AlertDescription className="text-sm">
        <p>{message}</p>
        {action ? <p className="mt-1 text-muted-foreground">{action}</p> : null}
      </AlertDescription>
    </Alert>
  );
}
